import React from 'react';
import PropTypes from 'prop-types';
import AmountWithCurrency from '../../common/AmountWithCurrency';

const BuyCryptoForm = ({
    formData,
    fieldError,
    handleAmountChange,
    handleCurrencyChange,
    exchangeRate,
    loadingRate,
    balancesCurrencies,
    updatedUnfreeze,
}) => {
    const hasError =
        fieldError?.fiatCurrency ||
        fieldError?.fiatAmount ||
        fieldError?.cryptoID ||
        fieldError?.cryptoAmount ||
        fieldError?.quotation;

    const allowedFiatCurrencies = ['USD', 'EUR', 'GBP'];

    const filteredFiatData = balancesCurrencies.filter(option => {
        if (option.currencyType === 'fiat') {
            return allowedFiatCurrencies.includes(option.currencyShortName);
        }
        return true;
    });

    return (
        <>
            <div className="relative">
                <div className="flex flex-col gap-[20px]  items-center w-full rounded-lg">
                    <AmountWithCurrency
                        errorMessage={fieldError.fiatCurrency || fieldError.fiatAmount}
                        isErrorVisible={false}
                        transactionLabel="YOU PAY"
                        data={filteredFiatData || []}
                        amountValue={formData.fiatAmount}
                        selected={formData.fiatCurrency}
                        onAmountChange={e => handleAmountChange('fiatAmount', e.target.value)}
                        onCurrencyChange={val => handleCurrencyChange('fiatCurrency', val)}
                        dataE2e="you-pay"
                    />
                    <AmountWithCurrency
                        errorMessage={fieldError.cryptoID || fieldError.cryptoAmount}
                        isErrorVisible={false}
                        transactionLabel="YOU GET"
                        data={updatedUnfreeze || []}
                        amountValue={formData.cryptoAmount}
                        selected={formData.cryptoID}
                        onAmountChange={e => handleAmountChange('cryptoAmount', e.target.value)}
                        onCurrencyChange={val => handleCurrencyChange('cryptoID', val)}
                        dataE2e="you-get"
                    />
                </div>
            </div>

            {hasError && (
                <p className="text-error text-sm font-normal font-Inter uppercase" data-e2e-error="alert" data-e2e={hasError} role="alert">
                    {hasError}
                </p>
            )}

            <div className="text-sm w-full font-medium flex items-center gap-2  bg-card-bg justify-center py-2 mt-3 rounded-lg">
                {loadingRate && (
                    <div className="animate-spin h-[18px] w-[18px] border-2 border-[#A0A0AB4D] rounded-full border-t-2 !border-t-primary" />
                )}
                <span className="!text-text">
                    1 {formData.cryptoID?.currencyShortName} ={' '}
                    {exchangeRate !== null ? exchangeRate : '?'}{' '}
                    {formData.fiatCurrency?.currencyShortName}
                </span>
            </div>
        </>
    );
};

BuyCryptoForm.propTypes = {
    formData: PropTypes.shape({
        fiatCurrency: PropTypes.shape({
            currencyShortName: PropTypes.string,
            data: PropTypes.array,
        }),
        cryptoID: PropTypes.shape({
            currencyShortName: PropTypes.string,
            data: PropTypes.array,
        }),
        fiatAmount: PropTypes.string,
        cryptoAmount: PropTypes.string,
    }),
    fieldError: PropTypes.shape({
        fiatCurrency: PropTypes.string,
        cryptoID: PropTypes.string,
        fiatAmount: PropTypes.string,
        cryptoAmount: PropTypes.string,
    }),
    handleAmountChange: PropTypes.func.isRequired,
    handleCurrencyChange: PropTypes.func.isRequired,
    exchangeRate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    loadingRate: PropTypes.bool,
    balancesCurrencies: PropTypes.array,
    updatedUnfreeze: PropTypes.array,
};

BuyCryptoForm.defaultProps = {
    formData: {},
    fieldError: {},
    loadingRate: false,
    balancesCurrencies: [],
    updatedUnfreeze: [],
};

export default BuyCryptoForm;
